import * as React from 'react'
import { styled } from 'next-yak'

import type { PolymorphicComponent, YakComponentOf } from '@owl-nest/yak/extra-runtime'

import * as S from '../../styles'

export type ClickableTagProps = {
  label: React.ReactNode
  icon?: React.ReactNode
  isActive?: boolean
} & React.ComponentPropsWithoutRef<'button'>

function ClickableTagComponent({
  label,
  icon,
  isActive = false,
  ...props
}: ClickableTagProps): React.ReactElement<ClickableTagProps> {
  return (
    <S.tag.ClickableTag $isActive={isActive} {...props}>
      {icon}
      {label}
    </S.tag.ClickableTag>
  )
}

export const ClickableTag = styled(ClickableTagComponent)<ClickableTagProps>`` as YakComponentOf<
  PolymorphicComponent<'button', ClickableTagProps>
>
ClickableTag.displayName = 'ClickableTag'
